import * as THREE from "three";

export const PURE_BLACK_MATERIAL = new THREE.MeshBasicMaterial({ color: 0x000000 });
